module.exports = __webpack_public_path__ + "img/time-activity-reports.f9cd230b.png";